/* Reproduction of Pixel Union's Load-In Animations (LIA) framework.
   Ported from live store's editions.js (LoadInAnimations.js module).
   The accompanying CSS keyframes live in atelier-page.css. */
(function () {
  'use strict';

  var CLASSES = {
    block:        'pxu-lia-block',
    element:      'pxu-lia-element',
    playBlock:    'pxu-lia-block--play',
    resetBlock:   'pxu-lia-block--reset',
    playSection:  'pxu-lia-section--play',
    resetSection: 'pxu-lia-section--reset'
  };

  var MAPPING_SELECTOR = 'script[type="application/pxs-animation-mapping+json"]';

  function addClasses(root) {
    root.querySelectorAll(MAPPING_SELECTOR).forEach(function (mappingEl) {
      var section = mappingEl.parentNode;
      if (!section) return;
      var mapping;
      try { mapping = JSON.parse(mappingEl.textContent || '{}'); }
      catch (e) { console.warn('Unable to parse animation mapping', mappingEl, e); return; }

      (mapping.elements || []).forEach(function (sel) {
        section.querySelectorAll(sel).forEach(function (el) {
          el.classList.add(CLASSES.element);
        });
      });
      (mapping.blocks || []).forEach(function (sel) {
        section.querySelectorAll(sel).forEach(function (el) {
          el.classList.add(CLASSES.block);
        });
      });
    });
  }

  function getMappingParent(node) {
    var p = node.parentElement;
    if (!p) return null;
    return p.querySelector(MAPPING_SELECTOR) ? p : getMappingParent(p);
  }

  function play(block) {
    block.style.animationPlayState = 'running';
    block.classList.add(CLASSES.playBlock);
    block.querySelectorAll('.' + CLASSES.element).forEach(function (el) {
      el.style.animationPlayState = 'running';
    });
  }

  function loadInAnimations(blocks) {
    var rafTasks = [];
    blocks.forEach(function (block, blockIndex) {
      block.style.setProperty('--pxu-lia-outer-sequence', String(blockIndex));
      var elements = block.querySelectorAll('.' + CLASSES.element);
      elements.forEach(function (el, elIndex) {
        el.style.setProperty('--pxu-lia-inner-sequence', String(elIndex));
      });
      play(block);
      var section = getMappingParent(block);
      if (section) {
        if (section.classList.contains(CLASSES.playSection)) {
          section.classList.add(CLASSES.resetSection);
          rafTasks.push(function () {
            section.classList.remove(CLASSES.resetSection);
            section.classList.add(CLASSES.playSection);
          });
        } else {
          section.classList.add(CLASSES.playSection);
        }
      }
    });
    window.requestAnimationFrame(function () {
      rafTasks.forEach(function (fn) { fn(); });
    });
  }

  function intersectionCallback(entries, observer) {
    var toAnimate = new Map();
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      var parent = getMappingParent(entry.target);
      var siblings = toAnimate.get(parent);
      toAnimate.set(parent, siblings ? siblings.concat(entry.target) : [entry.target]);
    });
    toAnimate.forEach(function (blocks) { loadInAnimations(blocks); });
  }

  function init() {
    if ('reduceAnimations' in document.body.dataset) return;
    addClasses(document);

    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.' + CLASSES.block).forEach(function (b) { play(b); });
      return;
    }
    var observer = new IntersectionObserver(intersectionCallback, { threshold: 0.3 });
    document.querySelectorAll('.' + CLASSES.block).forEach(function (b) {
      observer.observe(b);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
